// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".loading-wrap[data-v-7fa923a0] {\n  position: absolute;\n  z-index: 10;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n}\n.loading-box[data-v-7fa923a0] {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  width: 100px;\n  transform: translate(-50%, -50%);\n}\n", ""]);
// Exports
module.exports = exports;
